<template>
    <div>
        <v-simple-table>
            <template v-slot:default>
                <thead>
                    <tr>
                        <th>Number</th>
                        <th class="mx-auto text-center">Name</th>
                        <th class="mx-auto text-center">Amount of events</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item,index) in leagues" :key="index">
                        <td class="mx-auto">{{index+1}}.</td>
                        <td class="mx-auto text-center">{{item.leagueName}}</td>
                        <td class="mx-auto text-center">{{item.amountsOfEvents}}</td>
                        <td class="mx-auto text-center">
                            <v-icon left>fa-cog</v-icon>
                            <span>Configure</span>
                        </td>
                    </tr>
                </tbody>
            </template>
        </v-simple-table>  
    </div>
</template>
<script>
export default {
    name:"leagueList_admin",
    date(){
        return{

        }
    },
    computed:{
        leagues(){
            return this.$store.getters.getLeaguesAdmin;
        }
    }
}
</script>